export const ADMIN_TOKEN_KEY = 'adminToken';
export const ADMIN_ROLE_KEY = 'userRole';
export const PARTNER_TOKEN_KEY = 'loginToken';

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const getPartnerToken = () => localStorage.getItem(PARTNER_TOKEN_KEY);

export const isJwtValid = (token) => {
    if (!token) {
        return false;
    }

    try {
        const payloadPart = token.split('.')[1];
        if (!payloadPart) {
            return true;
        }

        const payload = JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.exp) {
            return true;
        }

        return payload.exp * 1000 > Date.now();
    } catch (error) {
        return false;
    }
};

export const hasValidAdminSession = () => isJwtValid(getAdminToken());

export const saveAdminSession = (token) => {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
    localStorage.setItem(ADMIN_ROLE_KEY, 'admin');
    localStorage.removeItem(PARTNER_TOKEN_KEY);
};

export const clearAdminSession = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    localStorage.removeItem(ADMIN_ROLE_KEY);
};

export const getAuthToken = () => {
    if (hasValidAdminSession()) {
        return getAdminToken();
    }

    return getPartnerToken();
};
